import {
  API_ROOT as BaseURL,
  CASINO_ROOT as CasinoURL,
  REPORTS_ROOT as ReportsURL,
  XOROPE_ROOT
} from "../configs/api";
import {
  OPERATOR_ID,
  MASTER_REPORT,
  deckHerosApi,
  realGamesApi,
} from "../configs/const";

import * as authUtil from "../util/auth.util";

// import * as Sentry from "@sentry/react";

export function get(request, params, options) {
  // var url = new URL(BaseURL + request);
  // if(request === 'marketprovider/markets'){
  //   const accessToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJyaWNreTEiLCJyb2xlIjoiQ2xpZW50IiwiaXNzIjoiUkRSIiwiZXhwIjoxNjc4Mzg3Njc4MTc2LCJwd2RjaCI6ZmFsc2UsImlwIjoiMjIzLjIyOS4xNDkuMjYifQ.gjwpxIwYGDtUY12eNT5Hnhb45Vt54UUPNm2fsWTNi68';
  //   options.headers = new Headers({
  //     "Content-Type": "application/json",
  //     "X-OP-KEY": OPERATOR_ID,
  //     Authorization: "Bearer " + accessToken,
  //   });
  // }
  if (JSON.parse(localStorage.getItem("userAuthDetail")) !== null) {
    const accessToken = JSON.parse(
      localStorage.getItem("userAuthDetail")
    ).token;
    options.headers = new Headers({
      "Content-Type": "application/json",
      "X-OP-KEY": OPERATOR_ID,
      Authorization: "Bearer " + accessToken,
    });
  }
  let url = new URL(BaseURL + request);
  if (request.includes(ReportsURL)) {
    url = new URL(request);
    if (JSON.parse(localStorage.getItem("userAuthDetail")) !== null) {
      const accessToken = JSON.parse(
        localStorage.getItem("userAuthDetail")
      ).token;
      options.headers = new Headers({
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
        "X-OP-KEY": OPERATOR_ID,
      });
    }
  }
  if (request.toString() === "sso/auth/requestcaptcha") {
    options.headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      "X-OP-KEY": OPERATOR_ID,
    });
  }
  if (request.toString() === "sso/auth/demo") {
    options.headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      "X-OP-KEY": OPERATOR_ID,
    });
  }
  if (request.includes(realGamesApi)) {
    url = new URL(request);
    if (JSON.parse(localStorage.getItem("userAuthDetail")) !== null) {
      const accessToken = JSON.parse(
        localStorage.getItem("userAuthDetail")
      ).token;
      options.headers = new Headers({
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
        "X-OP-KEY": OPERATOR_ID,
      });
    }
  }
  if (request.includes("sso/token/")) {
    options.headers = new Headers({
      "Content-Type": "application/json",
      "X-OP-KEY": OPERATOR_ID,
    });
  }
  if (request.includes(MASTER_REPORT)) {
    url = new URL(request);
    if (JSON.parse(localStorage.getItem("userAuthDetail")) !== null) {
      options.headers = new Headers({
        "Content-Type": "application/json",
      });
    }
  }
  if (request.toString() === "casino/games/LOTUS") {
    url = new URL(CasinoURL + request);
  }
  if (request.includes(deckHerosApi)) {
    url = new URL(request);
  }
  if (request.includes(XOROPE_ROOT)) {
    url = new URL(request);
    options.headers = new Headers({
      "Content-Type": "application/json",
    });
  }
  if (params !== null) {
    const keys = Object.keys(params);

    let temp = keys.length > 0 ? "?" : "";
    for (let i = 0; i < keys.length; i++) {
      temp += `${keys[i]}=${params[keys[i]]}${
        i === keys.length - 1 ? "" : "&"
      }`;
    }
    url = url + temp;
  }
  // let startTime = new Date().getTime()
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: "GET",
      headers: options.headers,
      crossDomain: true,
    })
      .then((response) => response)
      .then((res) => {
        // let endTime = new Date().getTime();
        // if(endTime - startTime > 3000){
        //     Sentry.captureMessage('Response time Exceed 3 sec - time taken: ' + (endTime - startTime)/1000 + ' sec in api url: ' + url + ' on route: ' + window.location.pathname)
        // }
        if (res.status === 403 || res.status === 401) {
          // let accountData = localStorage.getItem("accountData")
          //     accountData = JSON.parse(accountData)
          // Sentry.captureMessage('Logout by status: ' + res.status + ' in api url: ' + url + ' user:' + accountData.userId + ' @' + new Date().toISOString() + ' on route: ' + window.location.pathname)

          if (url.href.includes(realGamesApi) || url.href.includes('/maintenance')) {
            resolve({ hasError: true });
          } else {
            let appType = localStorage.getItem("appType");
            // let rememberData = localStorage.getItem("rememberData");
            // localStorage.clear();
            // localStorage.setItem("rememberData", rememberData);
            authUtil.logout(true);
            // if (appType === "mobile") {
            //   window.location.href = window.location.origin + "/apk";
            // } else {
            //   window.location.href = window.location.origin + "/auth";
            // }
          }
          // console.log(res)
          // resolve({hasError:true})
        } else if (res.status !== 204 && res.status !== 404) {
          resolve(res);
        } else {
          resolve({ hasError: true });
        }
      })
      .catch((error) => {
        // Sentry.captureException(error)
        reject(error);
      });
  });
}

export function post(request, body, options) {
  var url = new URL(BaseURL + request);
  if (request.includes(ReportsURL)) {
    url = new URL(request);
    if (JSON.parse(localStorage.getItem("userAuthDetail")) !== null) {
      const accessToken = JSON.parse(
        localStorage.getItem("userAuthDetail")
      ).token;
      options.headers = new Headers({
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
        "X-OP-KEY": OPERATOR_ID,
      });
    }
  } else if (request.includes(realGamesApi)) {
    url = new URL(request);
    if (JSON.parse(localStorage.getItem("userAuthDetail")) !== null) {
      const accessToken = JSON.parse(
        localStorage.getItem("userAuthDetail")
      ).token;
      options.headers = new Headers({
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
        "X-OP-KEY": OPERATOR_ID,
      });
    }
  } else if (request.toString() === "sso/auth") {
    options.headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      "X-OP-KEY": OPERATOR_ID,
    });
  } else if (request.includes(XOROPE_ROOT)) {
    url = new URL(request);
    options.headers = new Headers({});
  } else if(request.includes('pgi/Orders/manualpayment')){
    if (JSON.parse(localStorage.getItem("userAuthDetail")) !== null) {
      const accessToken = JSON.parse(
        localStorage.getItem("userAuthDetail")
      ).token;
      options.headers = new Headers({
        // "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
        "X-OP-KEY": OPERATOR_ID,
      });
    }
  } else if (request.includes('online/Check/sendotp') || request.includes('online/check/sendotp/bymail')) {
    
    options.headers = new Headers({
      "Content-Type": "application/json",
      "X-OP-KEY": OPERATOR_ID,
    });
} else {
    if (JSON.parse(localStorage.getItem("userAuthDetail")) !== null) {
      const accessToken = JSON.parse(
        localStorage.getItem("userAuthDetail")
      ).token;
      options.headers = new Headers({
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
        "X-OP-KEY": OPERATOR_ID,
      });
    }
  }
  // let startTime = new Date().getTime()
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: "POST",
      body: body,
      headers: options.headers,
      crossDomain: true,
    })
      .then((response) => response)
      .then((res) => {
        // let endTime = new Date().getTime();
        // if(!url.href.includes('order') && endTime - startTime > 3000){
        //     Sentry.captureMessage('Response time Exceed 3 sec - time taken: ' + (endTime - startTime)/1000 + ' sec in api url: ' + url + ' on route: ' + window.location.pathname)
        // }
        if (res.status === 403 || res.status === 401) {
          // let accountData = localStorage.getItem("accountData")
          //     accountData = JSON.parse(accountData)
          // Sentry.captureMessage('Logout by status: ' + res.status + ' in api url: ' + url + ' user:' + accountData.userId + ' @' + new Date().toISOString() + ' on route: ' + window.location.pathname)
          if (url.href.includes(realGamesApi)) {
            resolve({ hasError: true });
          } else {
            // let appType = localStorage.getItem("appType");
            // let rememberData = localStorage.getItem("rememberData");
            // localStorage.clear();
            // localStorage.setItem("rememberData", rememberData);
            authUtil.logout(true);
            // if (appType === "mobile") {
            //   window.location.href = window.location.origin + "/apk";
            // } else {
            //   window.location.href = window.location.origin + "/auth";
            // }
          }
          // console.log(res)
          // resolve({hasError:true})
        } else if (res.status !== 204 && res.status !== 404) {
          resolve(res);
        } else {
          resolve({ hasError: true });
        }
      })
      .catch((error) => {
        // Sentry.captureException(error)
        reject(error);
      });
  });
}
export function put(request, body, options) {
  if (JSON.parse(localStorage.getItem("userAuthDetail")) !== null) {
    const accessToken = JSON.parse(
      localStorage.getItem("userAuthDetail")
    ).token;
    options.headers = new Headers({
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
      "X-OP-KEY": OPERATOR_ID,
    });
  }
  // let startTime = new Date().getTime()
  return new Promise((resolve, reject) => {
    fetch(BaseURL + request, {
      method: "PUT",
      body: body,
      headers: options.headers,
    })
      .then((response) => response)
      .then((res) => {
        // let endTime = new Date().getTime();
        // if(endTime - startTime > 3000){
        //     Sentry.captureMessage('Response time Exceed 3 sec - time taken: ' + (endTime - startTime)/1000 + ' sec in api url: ' + BaseURL + request + ' on route: ' + window.location.pathname)
        // }
        if (res.status === 403 || res.status === 401) {
          // let accountData = localStorage.getItem("accountData")
          //     accountData = JSON.parse(accountData)
          // Sentry.captureMessage('Logout by status: ' + res.status + ' in api url: ' + BaseURL + request + ' user:' + accountData.userId + ' @' + new Date().toISOString() + ' on route: ' + window.location.pathname)
          // let appType = localStorage.getItem("appType");
          // let rememberData = localStorage.getItem("rememberData");
          // localStorage.clear();
          // localStorage.setItem("rememberData", rememberData);
          authUtil.logout(true);
          // if (appType === "mobile") {
          //   window.location.href = window.location.origin + "/apk";
          // } else {
          //   window.location.href = window.location.origin + "/auth";
          // }
          // console.log(res)
          // resolve({hasError:true})
        } else if (res.status !== 204 && res.status !== 404) {
          resolve(res);
        } else {
          resolve({ hasError: true });
        }
      })
      .catch((error) => {
        // Sentry.captureException(error)
        reject(error);
      });
  });
}
export function remove(request, options) {
  if (JSON.parse(localStorage.getItem("userAuthDetail")) !== null) {
    const accessToken = JSON.parse(
      localStorage.getItem("userAuthDetail")
    ).token;
    options.headers = new Headers({
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
      "X-OP-KEY": OPERATOR_ID,
    });
  } else {
    options.headers = new Headers({
      "Content-Type": "application/json",
      "X-OP-KEY": OPERATOR_ID,
    });
  }
  // let startTime = new Date().getTime()
  return new Promise((resolve, reject) => {
    fetch(BaseURL + request, {
      method: "DELETE",
      headers: options.headers,
    })
      .then((response) => response)
      .then((res) => {
        // let endTime = new Date().getTime();
        // if(endTime - startTime > 3000){
        //     Sentry.captureMessage('Response time Exceed 3 sec - time taken: ' + (endTime - startTime)/1000 + ' sec in api url: ' + BaseURL + request + ' on route: ' + window.location.pathname)
        // }
        if (res.status === 403 || res.status === 401) {
          // let accountData = localStorage.getItem("accountData")
          //     accountData = JSON.parse(accountData)
          // Sentry.captureMessage('Logout by status: ' + res.status + ' in api url: ' + BaseURL + request + ' user:' + accountData.userId + ' @' + new Date().toISOString() + ' on route: ' + window.location.pathname)
          // let appType = localStorage.getItem("appType");
          // let rememberData = localStorage.getItem("rememberData");
          // localStorage.clear();
          // localStorage.setItem("rememberData", rememberData);
          authUtil.logout(true);
          // if (appType === "mobile") {
          //   window.location.href = window.location.origin + "/apk";
          // } else {
          //   window.location.href = window.location.origin + "/auth";
          // }
          // console.log(res)
          // resolve({hasError:true})
        } else if (res.status !== 204 && res.status !== 404) {
          resolve(res);
        } else {
          resolve({ hasError: true });
        }
      })
      .catch((error) => {
        // Sentry.captureException(error)
        reject(error);
      });
  });
}
